import * as yup from 'yup'

import { scopedTranslation, i18nValidation } from '@utils/I18n'

const t = scopedTranslation('author_shifts')
const tShift = scopedTranslation('attributes.shift')

type ShiftFieldsOptions = {
  minVolunteers?: number
  minVolunteersMessage?: string
}

export const shiftFieldsSchema = ({ minVolunteers = 1, minVolunteersMessage }: ShiftFieldsOptions = {}) => ({
  role: yup
    .object({ value: yup.string().required(), label: yup.string().required() })
    .nullable()
    .label(tShift('role'))
    .required(i18nValidation('required')),
  startTime: yup.string().label(tShift('start_time')).required(i18nValidation('required')),
  endTime: yup
    .string()
    .label(tShift('end_time'))
    .required(i18nValidation('required'))
    .test('after-start', t('validation.end_after_start'), function (value) {
      return !value || !this.parent.startTime || value > this.parent.startTime
    }),
  volunteersRequired: yup
    .number()
    .label(tShift('volunteers'))
    .typeError(t('validation.min_volunteers'))
    .min(minVolunteers, minVolunteersMessage ?? t('validation.min_volunteers'))
    .required(i18nValidation('required')),
})
